import { createReducer } from "@reduxjs/toolkit";
import { CATEGORYAPPS_ERROR, CATEGORYAPPS_LOADING, CATEGORYAPPS_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const categoryAppsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CATEGORYAPPS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(CATEGORYAPPS_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(CATEGORYAPPS_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default categoryAppsReducer;
